import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Box, Typography } from "@mui/material";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import BackWithBreadcrumbAppbar from "../components/BackWithBreadcrumbAppbar";
import { useTranslation } from "react-i18next";
import AgendaPdf from "../Assets/AgendaInnovationLabProgramFinal.pdf";

pdfjs.GlobalWorkerOptions.workerSrc =
  "https://cdn.jsdelivr.net/npm/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs";

const InnovationProgram = () => {
  const { t } = useTranslation();
  const [numPages, setNumPages] = useState(null);

  return (
    <>
      <BackWithBreadcrumbAppbar
        links={[{ label: t("dashboard"), href: "/" }]}
        currentPage={t("AgendaInnovationProgram")}
      />

      <Box
        sx={{
          p: 3,
          height: "calc(100vh - 128px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h4" align="center" gutterBottom>
          {t("AgendaInnovationProgram")}
        </Typography>

        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            bgcolor: "background.paper",
          }}
        >
          <Document
            file={AgendaPdf}
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
            loading={<Typography align="center">Loading PDF...</Typography>}
            error={<Typography color="error">Error loading PDF</Typography>}
          >
            {Array.from({ length: numPages }, (_, i) => (
              <Page
                key={`page_${i + 1}`}
                pageNumber={i + 1}
                width={window.innerWidth - 48} // Adjust width to fit the window size
              />
            ))}
          </Document>
        </Box>
      </Box>
    </>
  );
};

export default InnovationProgram;

// import React from "react";
// import {
//   Container,
//   Typography,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Chip,
//   Divider,
//   Grid,
//   Avatar,
//   Link,
//   Box,
//   Stack,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(4),
//   marginBottom: theme.spacing(4),
//   borderRadius: "12px",
//   boxShadow: "0 8px 32px rgba(0,0,0,0.05)",
//   background: theme.palette.background.paper,
// }));

// const TeamHeader = styled(Box)(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   marginBottom: theme.spacing(1.5),
//   "& .MuiAvatar-root": {
//     marginRight: theme.spacing(2),
//     backgroundColor: theme.palette.primary.main,
//     width: 42,
//     height: 42,
//     fontSize: "1.1rem",
//   },
// }));

// const InnovationProgram = () => {
//   const hackathonDays = [
//     {
//       date: "7 April 2025",
//       teams: [
//         {
//           name: "Hydro-x",
//           members: [
//             "Sumaya Saif Alhashimi",
//             "Maryam Hamad Al Masrouri",
//             "Alhasna Nasser Al Adwaniya",
//             "Azza Sultan Al-Habsi",
//           ],
//         },
//         {
//           name: "Innov8",
//           members: [
//             "Ruwaida Nasser Alharasi",
//             "Mayadeen Jaber Al-Abri",
//             "Rafif Ibrahim Al Qasimi",
//           ],
//         },
//         { name: "Manar", members: ["Manar Al Jahwari"] },
//         { name: "Plan-B", members: ["Hesham Saeed Al Nasri"] },
//         { name: "Mariann", members: ["Mariann Al Baluchi"] },
//       ],
//     },
//     {
//       date: "8 April 2025",
//       teams: [
//         {
//           name: "Aqua Sense",
//           members: [
//             "Mujahid Mohammed Al-Suti",
//             "Osama Saud Al Busaidi",
//             "Al-Yaqdhan Badr Al-Rahbi",
//           ],
//         },
//         {
//           name: "Eco-Recovery",
//           members: [
//             "Shahd Maher Al-Maouli",
//             "Arwa Mohammed Al-Bahriya",
//             "Alaa Saeed Al-Khalili",
//           ],
//         },
//         { name: "Manar", members: ["Manar Al Jahwari"] },
//         { name: "Plan-B", members: ["Hesham Saeed Al Nasri"] },
//         { name: "Mariann", members: ["Mariann Al Baluchi"] },
//       ],
//     },
//     {
//       date: "9 April 2025",
//       teams: [{ name: "Plan-B", members: ["Hesham Saeed Al Nasri"] }],
//     },
//   ];

//   const researchProjects = [
//     {
//       title:
//         "The impact of the presence of dam fish as a natural aquaponics system",
//       supervisor: "Aziz bin Saeed Al-Hadi",
//       students: ["Omar bin Abdulaziz Al Rawahi", "Ibrahim bin Fouad Al-Wahibi"],
//       school: "Saeed bin Nasser Al-Kindi Basic Education",
//     },
//     {
//       title:
//         "Determining the quality of running water in Wadi Adi and its suitability for human use",
//       supervisor: "Aziz bin Saeed Al-Hadi",
//       students: [
//         "Al-Faisal bin Amer Al-Manji",
//         "Mohammed bin Khalid Alwohaibi",
//       ],
//       school: "Saeed bin Nasser Al-Kindi Basic Education",
//     },
//     {
//       title:
//         "Smart soils using capillary barriers, the future of sustainable agriculture in dry areas",
//       supervisor: "Manal bint Ali Al Qalhatia",
//       students: [
//         "Drarar bint Ahmed Albalushiya",
//         "Malak bint Yousef Al Rawahi",
//       ],
//       school: "Fatima Bint Al-Waleed for Basic Education",
//     },
//     {
//       title:
//         "Treatment of gray water using fungi found in the leaves of trees and a solution of cloves and garlic as a solution",
//       supervisor: "Halima bint Khamis Al Baluchiya",
//       students: ["Hanin bint Yahya Alghamaria", "Rawan bint Ahmed Alghamariya"],
//       school: "Zainab bint Abu Sufyan for Basic Education",
//     },
//     {
//       title:
//         "The emergence of white algae and its effect on the water characteristics in the Affaj of Qurayyat Governorate",
//       supervisor: "Shaikha bint Abdullah Al Maawliya",
//       students: [
//         "Mayar bint Muhammad al-Muwailiya",
//         "Al Jawhara bint Saif Al Khuzamiya",
//       ],
//       school: "Umm Al-Hakam bint Al-Zubair for Basic Education",
//     },
//   ];

//   const unescoChair = [
//     "Ishaq bin Nasser Al-Shubaibi",
//     "Amjad bin Salem Al Rawahi",
//   ];

//   const academicResearchers = [
//     {
//       title:
//         "Enhancing Oman Water Capabilities through Harvesting Water from Air",
//       researchers: ["Ibrahim Alhinai", "Aflah Al-Subhi", "Mubarak Al Habsi"],
//       institution: "Sultan Qaboos University",
//     },
//   ];

//   return (
//     <Container maxWidth="lg" sx={{ py: 6 }}>
//       <Box sx={{ textAlign: "center", mb: 6 }}>
//         <Typography
//           variant="h2"
//           sx={{
//             fontWeight: 800,
//             color: "primary.main",
//             mb: 2,
//             fontSize: { xs: "2.5rem", md: "3rem" },
//           }}
//         >
//           Innovation Lab Program
//         </Typography>
//         <Chip
//           label="Oman Water Week 2025"
//           variant="outlined"
//           sx={{
//             fontSize: "1.1rem",
//             px: 3,
//             py: 1.5,
//             borderWidth: 2,
//             borderColor: "primary.main",
//           }}
//         />
//       </Box>

//       {/* Hackathon Teams Section */}
//       {hackathonDays.map((day, index) => (
//         <StyledPaper key={index}>
//           <Typography
//             variant="h5"
//             sx={{
//               mb: 3,
//               fontWeight: 600,
//               color: "text.primary",
//               display: "flex",
//               alignItems: "center",
//               gap: 2,
//             }}
//           >
//             <Chip label={day.date} color="primary" sx={{ fontWeight: 700 }} />
//             <span>{day.teams.length} Teams</span>
//           </Typography>
//           <Divider sx={{ mb: 4 }} />

//           <Grid container spacing={4}>
//             {day.teams.map((team, teamIndex) => (
//               <Grid item xs={12} sm={6} lg={4} key={teamIndex}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 3,
//                     borderRadius: "8px",
//                     border: "1px solid",
//                     borderColor: "divider",
//                   }}
//                 >
//                   <TeamHeader>
//                     <Avatar>{team.name[0]}</Avatar>
//                     <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                       {team.name}
//                     </Typography>
//                   </TeamHeader>
//                   <List dense>
//                     {team.members.map((member, memberIndex) => (
//                       <ListItem key={memberIndex} sx={{ py: 0.5 }}>
//                         <ListItemText
//                           primary={member}
//                           primaryTypographyProps={{
//                             variant: "body2",
//                             sx: { fontWeight: 500 },
//                           }}
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </StyledPaper>
//       ))}

//       {/* Research Projects Section */}
//       <StyledPaper>
//         <Typography variant="h4" sx={{ mb: 4, fontWeight: 700 }}>
//           Research Projects
//         </Typography>
//         <Stack spacing={4}>
//           {researchProjects.map((project, index) => (
//             <Box key={index}>
//               <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5 }}>
//                 {project.title}
//               </Typography>
//               <Box
//                 sx={{
//                   display: "flex",
//                   gap: 2,
//                   flexWrap: "wrap",
//                   color: "text.secondary",
//                   fontSize: "0.9rem",
//                 }}
//               >
//                 <Chip
//                   label={`Supervisor: ${project.supervisor}`}
//                   variant="outlined"
//                   size="small"
//                 />
//                 <Chip
//                   label={`School: ${project.school}`}
//                   variant="outlined"
//                   size="small"
//                 />
//               </Box>
//               <List dense sx={{ mt: 1 }}>
//                 {project.students.map((student, i) => (
//                   <ListItem key={i} sx={{ py: 0.5 }}>
//                     <ListItemText
//                       primary={student}
//                       primaryTypographyProps={{ variant: "body2" }}
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//               {index !== researchProjects.length - 1 && (
//                 <Divider sx={{ mt: 3 }} />
//               )}
//             </Box>
//           ))}
//         </Stack>
//       </StyledPaper>

//       {/* UNESCO Chair Section */}
//       <StyledPaper>
//         <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
//           UNESCO Chair in Aflaj Studies
//         </Typography>
//         <List>
//           {unescoChair.map((name, index) => (
//             <ListItem key={index}>
//               <ListItemText
//                 primary={name}
//                 secondary="University of Nizwa"
//                 secondaryTypographyProps={{ color: "text.secondary" }}
//               />
//             </ListItem>
//           ))}
//         </List>
//       </StyledPaper>

//       {/* Academic Researchers Section */}
//       <StyledPaper>
//         <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
//           Academic Research
//         </Typography>
//         {academicResearchers.map((research, index) => (
//           <Box key={index} sx={{ mb: 3 }}>
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
//               {research.title}
//             </Typography>
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: 1,
//                 flexWrap: "wrap",
//                 color: "text.secondary",
//                 fontSize: "0.9rem",
//               }}
//             >
//               {research.researchers.map((researcher, i) => (
//                 <Chip
//                   key={i}
//                   label={researcher}
//                   variant="outlined"
//                   size="small"
//                 />
//               ))}
//               <Chip
//                 label={research.institution}
//                 color="primary"
//                 variant="outlined"
//                 size="small"
//               />
//             </Box>
//           </Box>
//         ))}
//       </StyledPaper>

//       {/* Footer */}
//       <Box
//         sx={{
//           mt: 8,
//           textAlign: "center",
//           py: 4,
//           borderTop: "1px solid",
//           borderColor: "divider",
//         }}
//       >
//         <Link
//           href="https://www.omanwaterweek.com"
//           target="_blank"
//           underline="none"
//           sx={{
//             "&:hover .MuiChip-root": {
//               backgroundColor: "action.hover",
//               transform: "translateY(-2px)",
//             },
//           }}
//         >
//           <Chip
//             label="www.omanwaterweek.com"
//             variant="outlined"
//             sx={{
//               fontSize: "1.1rem",
//               px: 4,
//               py: 1.5,
//               transition: "all 0.3s ease",
//               borderWidth: 2,
//               borderColor: "primary.main",
//             }}
//           />
//         </Link>
//       </Box>
//     </Container>
//   );
// };

// export default InnovationProgram;
